import { createFileRoute } from "@tanstack/react-router";
import { ServicePage, buildServiceMeta } from "@/components/ServicePage";
import { residentialContent } from "@/data/serviceContent";

const slug = "fence-cleaning";
const c = residentialContent[slug];

export const Route = createFileRoute("/residential/fence-cleaning")({
  head: () => buildServiceMeta({
    title: c.title,
    description: c.intro[0].slice(0, 155),
    path: "/residential/fence-cleaning",
  }),
  component: () => <ServicePage category="residential" slug={slug} {...c} />,
});
